// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6f926ed","667":"b285b2fe","821":"5bbfc9fe","963":"bd8ab68f","977":"0c72c402"}[chunkId] + ".chunk.js";
};